import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sendAccessLog } from "./accessLog";
import { getPageName } from "./pageNameMapping";

/**
 * ページ遷移時にアクセスログを自動送信するカスタムフック
 */
export const useAccessLog = () => {
  const location = useLocation();

  useEffect(() => {
    // ページパスを取得（クエリパラメータを含む）
    const fullPath = location.pathname + location.search;

    // 日本語画面名に変換
    const pagePath = getPageName(fullPath);

    // アクセスログを送信
    sendAccessLog(pagePath);
  }, [location.pathname, location.search]);
};
